<div class="container-fluid">
    <div class="row align-items-center mb-3">
        <div class="col-md-6">
        <h2 class="fw-bold mb-0">Aged Payable Report</h2>
        </div>

        <div class="col-md-6 text-md-end mt-2 mt-md-0">
        <button
            pButton
            icon="pi pi-refresh"
            label="REFRESH"
            class="btn btn-primary btn-sm me-2"
            (click)="getReportDetails()">
        </button>

        <button
            pButton
            icon="pi pi-file-excel"
            label="EXCEL"
            class="btn btn-danger btn-sm"
            (click)="getReportDetailsExcel()">
        </button>
        </div>
    </div>
    <!-- FILTER CARD -->
    <div class="card shadow-sm mb-4">
    <div class="card-body">

    <div class="row g-3">

      <!-- Date Range -->
      <div class="col-md-3 col-sm-12">
        <div class="form-group">
        <label class="form-label mb-0 fw-semibold">Date</label>
        <p-calendar
          [(ngModel)]="filterDate"
          dateFormat="dd/mm/yy"
          inputStyleClass="form-control w-100"
          appendTo="body"
          style="width: 100%">
        </p-calendar>
        </div>
      </div>
      <div class="col-md-3">
        <div class="form-group">
            <label class="form-label fw-semibold">Vendor</label>
            <p-multiSelect
              [options]="vendors"
              optionLabel="displayName"
              optionValue="id"
              display="chip"
              [(ngModel)]="selectedVendors"
              appendTo="body"
              style="width: 100%"
              class="w-100">
            </p-multiSelect>
          </div>
        </div>
    </div>

    </div>
    </div>
 <!-- LOADER -->
  <div *ngIf="loading" class="text-center p-4">
    <i class="fa fa-spinner fa-spin fa-3x"></i>
  </div>

    <!-- TABLE -->
  <div *ngIf="!loading && purchaseReportOutput != null">

    <div class="table-responsive">
      <table class="table table-bordered table-hover">

        <thead>
          <tr>
            <th>Vendor Name</th>
            <th>0 - 30</th>
            <th>31 - 60</th>
            <th>61 - 90</th>
            <th>91 - 120</th>
            <th>> 120</th>
            <th>Total</th>
          </tr>
        </thead>
        <tbody >
          <tr *ngFor="let purchaseReportOutputItem of purchaseReportOutput.items">
            <td >{{ purchaseReportOutputItem.vendorName }}</td>
            <td class="text-end">{{ purchaseReportOutputItem.amount30Days | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.amount60Days | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.amount90Days | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.amount120Days | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.amountGt120Days | number:'1.2-2'}}</td>
            <td class="text-end">{{ purchaseReportOutputItem.total | number:'1.2-2'}}</td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="table-dark text-white">
            <td class="text-center fw-bold">Total</td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.total30 | number: '1.2-2'}}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.total60 | number:'1.2-2' }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.total90 | number:'1.2-2' }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.total120 | number:'1.2-2' }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.totalGt120 | number:'1.2-2' }}
            </td>
            <td class="text-end fw-bold">
              {{ purchaseReportOutput.grandTotal | number:'1.2-2' }}
            </td>
          </tr>
        </tfoot>

      </table>
    </div>

  </div>

</div>